<template>
    <v-app id="single">
        <v-app-bar app color="black" dark clipped-left flat id="menu">
            <inertia-link :href="tenant ? '/' : route('artist', artist.artista_url)" class=" tw-min-w-0 tw-p-0 tw-bg-transparent tw-mr-2">
                <v-icon dark class="tw-text-lg">fas fa-arrow-left</v-icon>
            </inertia-link>
            <inertia-link :href="tenant ? '/' : route('artist', artist.artista_url)" v-if="loaded == true && pageOptions.logo"><v-img max-height="48px" max-width="48px" width="48px" height="48px" aspect-ratio="1" :src="pageOptions.logo" class="tw-rounded-full tw-object-cover" /></inertia-link>
            <inertia-link :href="tenant ? '/' : route('artist', artist.artista_url)" v-else-if="loaded == true && !artist.post_image"><v-img max-height="48px" max-width="48px" width="48px" height="48px" aspect-ratio="1" :src="spotifyArtist.images[2].url" class="tw-object-cover tw-rounded-full" /></inertia-link>
            <v-btn href="#" @click="follow({currentUser: currentUser, artist: artist}); clickFollow();" v-if="!following && artista_id !== artist.artista_id" class="dialogActivator waves-effect tw-rounded-full tw-px-5 tw-py-2 tw-bg-white tw-text-black tw-font-sans tw-text-xs tw-font-black tw-uppercase tw-tracking-wide tw-leading-none tw-ml-1 tw-transform tw-scale-90"><i class="fas fa-plus tw-mr-1"></i><span class="tw-leading-none">Seguir</span></v-btn>
            <v-btn href="#" @click="follow({currentUser: currentUser, artist: artist})" v-if="following && artista_id !== artist.artista_id" class="waves-effect tw-rounded-full tw-px-5 tw-py-2 tw-border-2 tw-bg-transparent tw-border-white tw-text-white tw-font-sans tw-text-xs tw-font-black tw-uppercase tw-tracking-wide tw-leading-none tw-ml-1 tw-transform tw-scale-90"><i class="fas fa-minus tw-mr-2"></i><span class="tw-leading-none">Seguindo</span></v-btn>
            <v-spacer></v-spacer>
            <a :href="artist.options.facebookUrl" target="_blank" class="tw-mx-2" v-if="loaded == true && artist.options.facebookUrl && artist.options.facebookUrl !== '#'">
                <v-icon dark class="tw-text-lg">fab fa-facebook</v-icon>
            </a>
            <a :href="artist.options.instagramUrl" target="_blank" class="tw-mx-2" v-if="loaded == true && artist.options.instagramUrl && artist.options.instagramUrl !== '#'">
                <v-icon dark class="tw-text-lg">fab fa-instagram</v-icon>
            </a>
            <a :href="artist.options.twitterUrl" target="_blank" class="tw-mx-2" v-if="loaded == true && artist.options.twitterUrl && artist.options.twitterUrl !== '#'">
                <v-icon dark class="tw-text-lg">fab fa-twitter</v-icon>
            </a>
            <a :href="'https://open.spotify.com/artist/'+artist.options.spotifyUrl" target="_blank" class="tw-mx-2" v-if="loaded == true && artist.options.spotifyUrl && artist.options.spotifyUrl !== '#'">
                <v-icon dark class="tw-text-lg">fab fa-spotify</v-icon>
            </a>
            <a :href="'https://youtube.com/channel/'+artist.options.youtubeUrl" target="_blank" class="tw-mx-2" v-if="loaded == true && artist.options.youtubeUrl && artist.options.youtubeUrl !== '#'">
                <v-icon dark class="tw-text-lg">fab fa-youtube</v-icon>
            </a>
            <a v-if="loaded == true && artist.options.lojaVirtualUrl !== 'undefined' ? (artist.options.lojaVirtualUrl ? artist.options.lojaVirtualUrl : false) : false" :href="artist.options.lojaVirtualUrl" target="_blank" class="tw-mx-2"> 
                <v-icon dark class="tw-text-lg">fas fa-store</v-icon>
            </a>
        </v-app-bar>
        <v-main>
            <login-dialog v-if="!Object.keys(this.currentUser).length" />
            <v-container fluid class="tw-p-0">
                <slot /> 
            </v-container>
        <snack-bar />
        </v-main>
    </v-app>
</template>

<script>
import EventBus from '@/eventbus';
import {TheMask} from 'vue-the-mask'
import SnackBar from '@/components/SnackBar';
import {mapState, mapActions} from 'vuex';
import LoginDialog from '@/components/login-popup';

export default {
    components: {TheMask, SnackBar, LoginDialog},
    data: () => ({
        pageOptions: '',
        drawer: false,
        artist: '',
        spotifyArtist: '',
        loaded: false,
        dialog: false,
        nameRules: [
            v => !!v || 'Nome é obrigatório',
            v => (v && v.length <= 32) || 'Nome precisa ter menos de 32 caracteres.',
        ],
        emailRules: [
            v => !!v || 'E-mail é obrigatório',
            v => /.+@.+\..+/.test(v) || 'Email precisa ser válido.',
        ],
    }),
    computed: {
        ...mapState('followstatus', ['following']),
    },
    methods:{
        ...mapActions('followstatus', ['follow', 'checkStatus']),
        redirectBack(){
            window.history.back();
        },
        clickFollow(){
            EventBus.$emit('clickFollow');
        }
    },
    mounted(){
        let vm = this;
        EventBus.$on('artist', (data) => {
            vm.pageOptions = data.pageOptions;
            vm.artist = data.artist;
            vm.spotifyArtist = data.spotifyArtist;
            vm.loaded = true
            vm.checkStatus({
                currentUser: vm.currentUser,
                artist: vm.artist,
            });
        });

        EventBus.$on('followUser', e => {
            vm.follow({currentUser: vm.currentUser, artist: vm.artist});
        })
    },
    watch: {
        currentUser(newVal, oldVal){
            if(Object.keys(newVal).length){
                this.checkStatus({
                    currentUser: this.currentUser,
                    artist: this.artist,
                });
            }
        }
    }
}
</script>

<style scoped>
    #single{
        background: #1f1f1f;
    }
</style>